var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDAppMaintenance = function SvgDAppMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 540 360"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 360,
    fill: "#FCF7F7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M182.575 175.753c-1.017 0-1.983-.203-2.728-.644l-61.328-35.4c-.797-.457-1.22-1.118-1.22-1.847 0-.847.593-1.678 1.644-2.271l60.497-34.926c1.847-1.067 4.575-1.169 6.185-.237l61.328 35.4c.796.458 1.22 1.119 1.22 1.848 0 .847-.593 1.677-1.644 2.27l-60.497 34.926c-1 .593-2.254.881-3.457.881m-2.254-1.457c1.305.762 3.711.644 5.236-.237l60.498-34.926c.729-.424 1.169-.966 1.169-1.457s-.407-.831-.745-1.017l-61.328-35.401c-1.305-.762-3.711-.643-5.237.238l-60.497 34.926c-.729.423-1.169.965-1.169 1.457 0 .491.407.83.745 1.017z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__a)",
    d: "M248.174 117.949v7.582l-65.638 37.902-65.638-37.902v-7.582z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__b)",
    d: "M248.174 117.949v7.582l-65.638 37.902-65.638-37.902v-7.582z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__c)",
    d: "m182.536 155.842-65.638-37.894 65.638-37.893 65.638 37.893z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m182.536 154.956-64.866-37.455-.772.447 65.638 37.894 65.638-37.894-.772-.438z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m182.539 147.107-50.481-29.15 50.481-29.142 50.482 29.142z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__d)",
    d: "m182.538 147.107-50.481-29.15 50.481-29.142 50.482 29.142z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__e)",
    d: "m182.539 81.46 50.482 29.15v7.346l-50.482-29.15z",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__f)",
    d: "m182.538 88.807-50.481 29.149v-7.346l50.481-29.15z",
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__g)",
    d: "m182.538 139.752-50.481-29.142 50.481-29.15 50.482 29.15z",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m182.539 122.256-20.17-11.645 20.17-11.646 20.17 11.646z",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m182.539 100.03 19.244 11.117.926-.536-20.17-11.646-20.17 11.646.927.536z",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__h)",
    d: "M182.539 139.751v7.355l50.482-29.15v-7.346z",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__i)",
    d: "M132.057 110.61v7.347l50.481 29.149v-7.354z",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m182.539 138.955-49.791-28.751-.69.406 50.481 29.142 50.482-29.142-.691-.406z",
    opacity: 0.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M394.402 299.591c-1.017 0-1.983-.204-2.728-.644l-61.328-35.401c-.796-.457-1.22-1.118-1.22-1.847 0-.847.593-1.677 1.644-2.27l60.497-34.926c1.847-1.068 4.576-1.17 6.185-.237l61.328 35.4c.797.457 1.22 1.118 1.22 1.847 0 .847-.593 1.678-1.643 2.271l-60.498 34.926c-1 .593-2.254.881-3.457.881m-2.254-1.458c1.305.763 3.711.644 5.237-.237l60.497-34.926c.729-.423 1.169-.966 1.169-1.457s-.406-.83-.745-1.017l-61.328-35.4c-1.305-.763-3.711-.644-5.236.237l-60.498 34.926c-.728.424-1.169.966-1.169 1.457s.407.831.746 1.017z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__j)",
    d: "M460.002 241.786v7.582l-65.638 37.902-65.637-37.902v-7.582z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__k)",
    d: "M460.002 241.786v7.582l-65.638 37.902-65.637-37.902v-7.582z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__l)",
    d: "m394.364 279.68-65.637-37.894 65.637-37.894 65.638 37.894z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m394.364 278.794-64.865-37.455-.772.447 65.637 37.894 65.638-37.894-.772-.439z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m394.367 270.944-50.481-29.15 50.481-29.141 50.482 29.141z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__m)",
    d: "m394.366 270.944-50.481-29.15 50.481-29.141 50.482 29.141z",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__n)",
    d: "m394.366 205.298 50.482 29.15v7.346l-50.482-29.149z",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__o)",
    d: "m394.366 212.645-50.481 29.149v-7.346l50.481-29.15z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__p)",
    d: "m394.366 263.59-50.481-29.142 50.481-29.15 50.482 29.15z",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m394.367 246.094-20.17-11.646 20.17-11.645 20.17 11.645z",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m394.367 223.868 19.244 11.117.926-.537-20.17-11.645-20.17 11.645.927.537z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__q)",
    d: "M394.366 263.589v7.355l50.482-29.15v-7.346z",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__r)",
    d: "M343.885 234.448v7.347l50.481 29.149v-7.354z",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m394.367 262.793-49.791-28.752-.69.406 50.481 29.142 50.482-29.142-.691-.406z",
    opacity: 0.8
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9EA1B6",
    d: "m178.791 192.538 16.981-100.796-1.357-.576 2.056-1.172v.02c.391-.266.966-.246 1.583.104l135.786 78.387c1.11.638 1.953 2.303 1.768 3.454l-17.125 101.598c-.082.535-.349.884-.719 1.028l-2.015 1.151-.349-1.87.123.041-134.964-77.915c-1.11-.638-1.973-2.303-1.768-3.454"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABACC0",
    d: "m333.08 171.26 2.241-.987c.246.576.37 1.172.287 1.686l-17.124 101.598c-.083.535-.35.884-.72 1.028l-2.015 1.151-.349-1.87.123.041-6.825-3.947z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "m178.421 197.226 135.786 78.387c1.048.597 1.953.247 2.138-.822l17.125-101.598c.205-1.151-.658-2.796-1.768-3.454L195.915 91.351c-1.048-.596-1.953-.246-2.138.823l-17.124 101.598c-.185 1.151.657 2.796 1.768 3.454"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5891",
    d: "m197.683 97.827 130.893 75.551-16.22 95.697-130.811-75.509 16.138-95.74z",
    opacity: 0.51
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__s)",
    d: "m93.064 245.312 7.401 3.864 74.297-42.904c1.233-.72 3.412-.638 4.851.205l128.159 73.989c1.234-.679 6.826-3.372 6.826-3.372l-2.714 7.072h-.021c-.102.309-.349.617-.76.843l-78.265 45.187c-1.233.719-3.412.637-4.852-.206l-131.14-75.715c-.596-.35-.945-.761-1.11-1.172z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__t)",
    d: "m93.064 245.312 7.401 3.864 74.297-42.904c1.233-.72 3.412-.638 4.851.205l128.159 73.989c1.234-.679 6.826-3.372 6.826-3.372l-2.714 7.072h-.021c-.102.309-.349.617-.76.843l-78.265 45.187c-1.233.719-3.412.637-4.852-.206l-131.14-75.715c-.596-.35-.945-.761-1.11-1.172z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__u)",
    d: "m94.216 246.544 134.409 77.607c1.48.843 3.7.946 4.975.206l80.197-46.297c1.274-.74 1.11-2.015-.35-2.878l-134.409-77.607c-1.48-.843-3.7-.946-4.975-.206l-80.197 46.318c-1.274.719-1.13 1.994.35 2.857"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__v)",
    d: "m94.216 246.544 134.409 77.607c1.48.843 3.7.946 4.975.206l80.197-46.297c1.274-.74 1.11-2.015-.35-2.878l-134.409-77.607c-1.48-.843-3.7-.946-4.975-.206l-80.197 46.318c-1.274.719-1.13 1.994.35 2.857"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m94.217 245.763 134.409 77.607c1.48.843 3.7.946 4.975.206l80.197-46.297c.411-.247.657-.535.781-.864.205.596-.041 1.213-.781 1.645l-80.197 46.297c-1.275.74-3.495.637-4.975-.206l-134.41-77.607c-.986-.575-1.377-1.336-1.13-1.994.144.432.514.864 1.13 1.213z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M269.166 307.355v-1.48c0-.144-.082-.206-.185-.144l-5.201 3.001c-.103.062-.185.226-.185.37v1.481c0 .143.082.205.185.143l5.201-3.001c.103-.062.185-.226.185-.37m-7.771 4.481v-1.48c0-.144-.083-.205-.185-.144l-5.202 3.002c-.102.061-.185.226-.185.37v1.48c0 .144.083.206.185.144l5.202-3.002c.102-.061.185-.226.185-.37"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ADB1F2",
    d: "m292.891 273.701-111.692-64.49a2.4 2.4 0 0 0-2.406 0l-39.78 23.004a.85.85 0 0 0 0 1.48l111.631 64.45c.74.431 1.665.431 2.405 0l39.842-22.964a.85.85 0 0 0 0-1.48"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__w)",
    d: "m292.891 273.701-111.692-64.49a2.4 2.4 0 0 0-2.406 0l-39.78 23.004a.85.85 0 0 0 0 1.48l111.631 64.45c.74.431 1.665.431 2.405 0l39.842-22.964a.85.85 0 0 0 0-1.48"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8DA5",
    d: "m292.889 275.181-.391.227-111.301-64.265a2.39 2.39 0 0 0-2.405 0l-39.369 22.778-.391-.226a.85.85 0 0 1 0-1.48l39.78-23.004a2.39 2.39 0 0 1 2.405 0l111.692 64.49a.857.857 0 0 1-.02 1.48"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "m175.787 215.05 97.014 56 4.317-2.488-97.013-56zm-10.585 6.105 91.011 52.526 4.317-2.488-91.01-52.526zm-6.886 3.968 107.149 61.86 4.317-2.488-107.148-61.859zm-6.888 3.988 107.148 61.859 4.318-2.508-107.149-61.859zm-6.887 3.968 107.149 61.859 4.317-2.487-107.149-61.86zm134.12 41.363 4.318 2.487 4.317-2.487-4.317-2.488zm-15.21 3.433 8.963 5.16 4.317-2.487-8.963-5.16z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__x)",
    d: "m176.901 289.306-30.117-17.393c-1.172-.678-1.172-1.788 0-2.466l20.599-11.883c1.172-.678 3.083-.678 4.255 0l30.118 17.392c1.172.679 1.172 1.789 0 2.467l-20.599 11.883c-1.172.678-3.084.678-4.256 0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__y)",
    d: "m176.901 289.306-30.117-17.393c-1.172-.678-1.172-1.788 0-2.466l20.599-11.883c1.172-.678 3.083-.678 4.255 0l30.118 17.392c1.172.679 1.172 1.789 0 2.467l-20.599 11.883c-1.172.678-3.084.678-4.256 0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8DA5",
    d: "m201.755 275.963-30.118-17.392c-1.172-.678-3.083-.678-4.255 0l-20.599 11.883c-.37.205-.597.452-.741.719-.308-.596-.082-1.254.741-1.726l20.599-11.883c1.172-.678 3.083-.678 4.255 0l30.118 17.392c.822.473 1.048 1.131.74 1.727-.144-.267-.391-.514-.74-.72"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__z)",
    d: "M178.892 197.41 313.3 274.996c1.48.843 3.701.946 4.975.206l80.197-46.297c1.275-.74 1.111-2.015-.349-2.878L263.714 148.42c-1.48-.843-3.7-.945-4.975-.205l-80.197 46.317c-1.275.74-1.11 2.015.35 2.878",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__A)",
    d: "m313.711 211.329-30.118-17.393c-1.172-.678-1.172-1.788 0-2.466l20.599-11.883c1.172-.678 3.084-.678 4.256 0l30.117 17.392c1.172.678 1.172 1.789 0 2.467l-20.599 11.883c-1.172.678-3.083.678-4.255 0",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9198DB",
    d: "m338.566 197.965-30.117-17.392c-1.172-.679-3.084-.679-4.256 0l-20.599 11.882c-.37.206-.596.453-.74.72-.308-.596-.082-1.254.74-1.727l20.599-11.883c1.172-.678 3.084-.678 4.256 0l30.117 17.393c.823.472 1.049 1.13.74 1.726-.143-.246-.39-.493-.74-.719",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ADB1F2",
    d: "m351.806 238.484-111.692-64.49a2.4 2.4 0 0 0-2.406 0l-39.78 23.004a.85.85 0 0 0 0 1.48l111.651 64.45c.74.432 1.665.432 2.406 0l39.821-22.984c.575-.288.575-1.131 0-1.46",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9198DB",
    d: "m351.805 239.985-.391.226-111.301-64.264a2.39 2.39 0 0 0-2.405 0l-39.369 22.778-.391-.226a.85.85 0 0 1 0-1.48l39.78-23.005a2.39 2.39 0 0 1 2.405 0l111.692 64.491c.556.308.556 1.151-.02 1.48",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24126A",
    d: "m208.33 195.457 97.302 56.165-3.845 2.241-97.301-56.186zm10.259-5.921 92.491 53.389-3.865 2.221-92.47-53.39zm99.399 57.378 8.634 4.995-3.865 2.22-8.634-4.995zm-7.628 7.441 6.003 3.475-3.844 2.22-6.024-3.474zm-85.356-68.54 108.033 62.373-3.844 2.22-108.033-62.352zm6.434-3.7 108.033 62.373-3.865 2.22-108.033-62.373zm6.414-3.721 108.033 62.373-3.845 2.241-108.032-62.374z",
    opacity: 0.11
  })))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m247.946 145.165 25.824 14.31 34.509 19.122-6.484 45.244-58.791-34.151z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__B)",
    d: "m247.946 145.165 25.824 14.31 34.509 19.122-6.484 45.244-58.791-34.151z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "m197.8 144.3 25.846 14.31 34.488 19.122-5.62 43.083-60.088-33.718z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppMaintenance_svg__C)",
    d: "m197.8 144.3 25.846 14.31 34.488 19.122-5.62 43.083-60.088-33.718z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M265.727 210.052c-.03-3.513-2.059-10.266-2.059-10.266-1.121 1.09-7.389 0-7.389 0-1.635 3.331-2.695 6.723-5.39 9.266-2.756 2.574-6.844 5.239-7.207 5.663-1.302 1.605-.182 3.331 1.453 3.997 1.333.545 2.726.697 4.119.576 1.453-.121 2.786-.576 4.057-1.181l11.084-5.3a2.28 2.28 0 0 0 1.302-1.817c.03-.333.03-.635.03-.938m-16.776-9.024c.333-3.422-1.332-10.114-1.332-10.114-1.212.969-6.208-.424-6.208-.424-1.968 3.089-3.937 5.784-6.874 7.964-2.968 2.241-7.268 4.391-7.631 4.755-1.423 1.423-.515 3.24.999 4.057 1.242.667 2.604.969 3.967 1 1.423.03 2.786-.273 4.088-.727l11.386-3.997c.727-.273 1.302-.878 1.454-1.635.06-.243.121-.576.151-.879"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF8F9B",
    d: "M258.035 107.699c-4.3 3.24-8.6 6.238-10.932 8.025-.363.272-2.695 1.393-5.208 2.513a6.5 6.5 0 0 0-1.787-1.484l-9.206-5.238c.697-.273 1.484-.424 2.241-.364 2.877.152 7.086.212 9.024-.666.333-.151.697-.303 1.242-.666 2.301-1.514 4.663-3.967 6.904-6.511z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "m270.449 64.033-7.51 7.843s-3.755 20.713-4.481 21.5c-2.181 2.362-11.689 12.173-15.747 16.837l6.601 3.876c6.208-4.058 19.078-13.355 21.289-16.564 1.877-2.726 4.3-30.495 4.3-30.495-.182-.969-3.483-3.21-4.452-2.997"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0E8",
    d: "m279.354 129.441 3.725-20.228c-4.815-.273-9.872-.515-13.748-.606-4.028-.061-6.965 4.724-6.965 5.178 0 0-26.557 23.741-26.557 29.646 0 7.692 1.847 38.64 2.937 49.542.272 2.634 9.66 2.604 10.084.333 2.029-10.781 3.149-34.643 3.24-44.303z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDF1",
    d: "m299.281 115.301-.182-1.151c-4.209-.242-9.539 3.24-12.9 3.179-1.938-.03-3.574-1.393-5.421-.121-.454.303-5.208-1.998-5.602-1.665-.363.303-.424.969-.303 1.817.939 6.995-20.682 26.072-20.682 33.189 0 15.656-1.091 40.517 0 51.358.272 2.635 10.81 1.787 11.022.303 1.484-10.357 5.996-36.641 6.087-46.332l18.26-15.05c8.54-6.662 12.658-15.08 9.721-25.527"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M261.123 116.45c2.15 1.756 10.326 6.056 17.261 6.904 2.755.333 5.36.484 7.752.484 6.571 0 11.689-1.211 14.263-3.512-.061-.303-.152-.576-.212-.879a25 25 0 0 1-.636-4.269c-.061-.939-.061-1.878-.061-2.817l.121-3.209-.575-14.718 6.844-12.748c0-7.026-6.057-12.113-11.962-15.747-.454-.272-.938-.545-1.393-.817-.151-.091-.272-.152-.424-.243l-4.905-2.846-4.149-2.392c-.454-.212-3.846 1.635-4.3 1.483-1.181-.484-2.392-.817-3.603-.938-5.572-.576-12.355 4.754-12.355 12.446l2.24 27.344c1.121 8.388-3.906 16.474-3.906 16.474"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M288.833 62.942V49.133h-10.054v14.081s-4.027 4.028-.939 5.875c4.906 2.907 10.993-1.968 10.993-6.147"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC7F7F",
    d: "M286.016 44.5c-2.544 3.028-3.089 6.783-1.242 8.358 1.878 1.575 4.967.636 7.995-2.665 2.725-2.968 3.088-6.662 3.088-6.662s-7.298-2.09-9.841.97z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M286.62 122.083c6.359 0 10.932-1.544 13.597-2.634a25 25 0 0 1-.636-4.27l-4.3-4.936-1.817-23.287-3.392 18.623-2.937 10.751s-.515 5.511-.515 5.753"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2BBBF",
    d: "M278.775 51.043v11.568c0 1.211 2.453 1.968 4.452 1.15 3.058-1.241 5.572-3.664 5.572-6.238v-6.48z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M272.325 54.676c1.545 8.207 6.996 9.055 12.113 6.632 3.452-1.635 6.45-4.118 7.238-7.722.514-2.332 2.301-4.542 2.452-6.48.606-7.45-4.027-12.386-10.205-12.87-14.051-1.15-12.143 17.594-11.598 20.44"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M269.933 36.052c.121-.575.333-1.12.666-1.544 1.484-2.271 5.058-2.937 9.055-3.967a16 16 0 0 1 5.663-.424c6.359.727 11.052 5.45 11.507 10.447.302 3.422-.182 5.875-.909 7.632-.757 1.786-1.786 2.876-2.665 3.512.152-.545.182-1.544-.151-3.482-.121-.727-1.393-.545-2.15.454-.303.394-.969.727-1.666.939a1.856 1.856 0 0 1-2.422-1.635 8 8 0 0 0-.363-1.817c-.061-.182-.122-.394-.182-.546-.364-.878-.212-1.877.424-2.573l2.15-2.544-2.059 1.514c-1.03.727-2.423.969-3.574.424-2.513-1.15-5.814-1-8.115-1.211-1.09-.091-2.15.545-2.393 1.635l-.151.605c-.061 0-3.573-2.755-2.665-7.419"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBAC0",
    d: "M289.195 48.952c-1.272 1.786-1.363 3.906-.182 4.754 1.181.817 3.15.03 4.422-1.756s1.362-3.907.181-4.755c-1.181-.817-3.149-.03-4.421 1.757"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#9498AD",
    d: "M290.073 130.985a2.39 2.39 0 0 0-1.181-2.15l-33.583-19.411a4.71 4.71 0 0 0-4.724 0l-20.44 11.81c-.848.485-1.212 1.363-1.181 2.211v1.302c.03.757.423 1.514 1.181 1.938l33.582 19.381a4.7 4.7 0 0 0 4.724 0l20.41-11.78a2.34 2.34 0 0 0 1.181-1.847v-1.454z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#525A8E",
    d: "m266.816 142.644-9.417-23.105a6.8 6.8 0 0 0-2.877-3.301l-29.495-16.776c-.696-.394-1.544-.303-2.271.12l-.151.092-.788.514c-1.423.636-2.089 2.272-1.514 3.695l8.903 22.863a5.33 5.33 0 0 0 2.392 2.755l30.494 17.473c.697.394 1.484.333 2.211-.06-.061.03 1.423-.909 1.423-.909 1.151-.666 1.605-2.089 1.09-3.361"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M275.236 125.294c5.875-2.332 22.227-7.813 27.103-11.871 2.24-1.877 2.089-30.191 2.089-30.191a1.515 1.515 0 0 0-1.423-1.665l-6.48-.455c-.848-.06-1.606.606-1.636 1.454-.182 3.482-.333 19.562-.454 23.589a2.17 2.17 0 0 1-1.544 2.029c-4.119 1.272-11.114 7.692-17.958 9.903-.635.212-1.06.393-1.423.424-3.361.484-9.508-4.422-10.235-1.121 0 0-6.692 3.573-2.695 7.268.696.636 5.995 2.574 7.6 2.543 3.301-.121 6.269-1.604 7.056-1.907"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M273.51 118.51c1.786.545 3.149 5.087 2.12 6.631 0 0 22.287-4.966 27.708-11.749 2.634-3.301 2.301-20.531 2.574-31.009.09-3.452-2.756-6.238-6.178-6.087-3.058.121-5.511 2.574-5.693 5.633-.363 6.874-.908 20.561-.999 23.287 0 .363-.243.605-.576.757-1.302.727-18.956 12.537-18.956 12.537"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M287.255 51.859c0-3.27 1.877-6.935 4.482-8.449 1.15-.666 2.149-.757 2.937-.393l1.817.999-.545.394c.242.575.393 1.302.393 2.15 0 3.27-1.938 7.025-4.602 8.57-.455.272-.879.393-1.303.484l.243.908-1.817-1.06c-1-.484-1.605-1.756-1.605-3.603"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M298.188 47.65c0-3.271-1.938-4.725-4.603-3.18-2.604 1.514-4.481 5.178-4.481 8.448s1.877 4.846 4.481 3.331c2.665-1.574 4.603-5.33 4.603-8.6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#424E7F",
    d: "M296.976 48.557c0-2.15-1.272-3.089-3.028-2.09-1.726 1-2.937 3.392-2.937 5.542s1.241 3.18 2.937 2.18c1.756-.999 3.028-3.482 3.028-5.632"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M269.299 44.289c0 1.847.605 3.119 1.635 3.603l.999.545c0-1.696.606-4.996.606-4.996s-1.787-1.393-2.574-4.3c-.242.848-.666 4.33-.666 5.148m8.541-13.234s3.937-.212 5.632.817l4.482 2.272c2.695 1.635 4.421 4.754 4.421 8.024l-.06 1.726 2.513-.151v-1.575c0-4.118-2.15-8.025-5.693-10.175l-4.845-2.422a5.124 5.124 0 0 0-6.45 1.484"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__a",
    x1: 84.448,
    x2: 252.663,
    y1: 140.689,
    y2: 140.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__b",
    x1: 118.269,
    x2: 130.256,
    y1: 151.564,
    y2: 101.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__c",
    x1: 182.536,
    x2: 182.536,
    y1: 80.055,
    y2: 155.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__d",
    x1: 132.054,
    x2: 233.022,
    y1: 117.957,
    y2: 117.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__e",
    x1: 182.538,
    x2: 233.022,
    y1: 99.706,
    y2: 99.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__f",
    x1: 132.055,
    x2: 182.539,
    y1: 99.706,
    y2: 99.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__g",
    x1: 132.054,
    x2: 233.022,
    y1: 110.602,
    y2: 110.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__h",
    x1: 182.538,
    x2: 233.022,
    y1: 128.855,
    y2: 128.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__i",
    x1: 132.055,
    x2: 182.539,
    y1: 128.856,
    y2: 128.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__j",
    x1: 296.276,
    x2: 464.491,
    y1: 264.526,
    y2: 264.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__k",
    x1: 330.097,
    x2: 342.084,
    y1: 275.401,
    y2: 225.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__l",
    x1: 394.364,
    x2: 394.364,
    y1: 203.892,
    y2: 279.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__m",
    x1: 343.882,
    x2: 444.85,
    y1: 241.794,
    y2: 241.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__n",
    x1: 394.365,
    x2: 444.849,
    y1: 223.544,
    y2: 223.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__o",
    x1: 343.883,
    x2: 394.368,
    y1: 223.544,
    y2: 223.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__p",
    x1: 343.882,
    x2: 444.85,
    y1: 234.44,
    y2: 234.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__q",
    x1: 394.365,
    x2: 444.849,
    y1: 252.693,
    y2: 252.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__r",
    x1: 343.883,
    x2: 394.368,
    y1: 252.694,
    y2: 252.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__s",
    x1: 314.61,
    x2: 93.067,
    y1: 268.24,
    y2: 268.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#5C66D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#6A73DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#8289E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#A3A7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__t",
    x1: 312.285,
    x2: 263.098,
    y1: 298.092,
    y2: 171.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__u",
    x1: 240.171,
    x2: 18.51,
    y1: 260.852,
    y2: 260.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__v",
    x1: 203.828,
    x2: 203.828,
    y1: 196.873,
    y2: 324.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__w",
    x1: 215.952,
    x2: 215.952,
    y1: 208.887,
    y2: 298.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__x",
    x1: 202.634,
    x2: 145.894,
    y1: 273.436,
    y2: 273.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__y",
    x1: 174.27,
    x2: 174.27,
    y1: 257.055,
    y2: 289.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__z",
    x1: 324.856,
    x2: 103.194,
    y1: 211.721,
    y2: 211.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__A",
    x1: 339.444,
    x2: 282.705,
    y1: 195.45,
    y2: 195.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__B",
    x1: 248,
    x2: 281.297,
    y1: 224.2,
    y2: 134.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppMaintenance_svg__C",
    x1: 225.28,
    x2: 225.28,
    y1: 144.3,
    y2: 220.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })))));
};
export default SvgDAppMaintenance;